export function constVoid() {}
